(function () {

    const isFrench = window.location.hostname.includes(".fr");

    function translateNotifications() {

        document.querySelectorAll(".notification-preview-text").forEach(block => {

            const paragraphs = block.querySelectorAll("p");

            if (paragraphs.length >= 3) {

                // First line
                if (isFrench) {

                    paragraphs[0].innerHTML = paragraphs[0].innerHTML
                        .replace(/ hat gekauft:/g, " a acheté :")
                        .replace(/ in /g, " à ");

                } else {

                    paragraphs[0].innerHTML = paragraphs[0].innerHTML
                        .replace(/ a acheté :/g, " hat gekauft:")
                        .replace(/ à /g, " in ");
                }

                // Time line
                if (isFrench) {

                    paragraphs[2].innerHTML = paragraphs[2].innerHTML
                        .replace(/vor/g, "il y a")
                        .replace(/Stunde\(n\)/g, "heure(s)");

                } else {

                    paragraphs[2].innerHTML = paragraphs[2].innerHTML
                        .replace(/il y a/g, "vor")
                        .replace(/heure\(s\)/g, "Stunde(n)");
                }
            }
        });
    }

    setInterval(translateNotifications, 500);

})();